import { render } from "./MultiTestForm.vue?vue&type=template&id=285f58a0"
import script from "./MultiTestForm.vue?vue&type=script&lang=js"
export * from "./MultiTestForm.vue?vue&type=script&lang=js"

import "./MultiTestForm.vue?vue&type=style&index=0&id=285f58a0&lang=scss"

import exportComponent from "/builds/lahautesociete/projects/roche/depistage-diabete/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__